import { isNumber } from '@sajari/react-sdk-utils';
import { useCallback } from 'react';
import { useContext } from '../ContextProvider/context.esm.js';

function useResultsPerPage() {
  var _useContext = useContext(),
      _useContext$search = _useContext.search,
      search = _useContext$search.search,
      resultsPerPageParam = _useContext$search.config.resultsPerPageParam,
      variables = _useContext$search.variables,
      defaultResultsPerPage = _useContext$search.defaultResultsPerPage;

  var setResultsPerPage = useCallback(function (size) {
    var _variables$set;

    variables.set((_variables$set = {}, _variables$set[resultsPerPageParam] = size, _variables$set));
    search();
  }, [variables, search]);
  var resultsPerPage = parseInt(variables.get()[resultsPerPageParam], 10);
  return {
    resultsPerPage: isNumber(resultsPerPage) ? resultsPerPage : defaultResultsPerPage,
    defaultResultsPerPage: defaultResultsPerPage,
    setResultsPerPage: setResultsPerPage
  };
}

export default useResultsPerPage;
//# sourceMappingURL=index.esm.js.map
